/**
 * This is a tolerance value for surface cut-fill coloring
 */
export const CUT_FILL_TOLERANCE = 0.02;